// extracted by mini-css-extract-plugin
export var wrapper = "GDPRBanner-module--wrapper--25hNC";
export var wrapper_show = "GDPRBanner-module--wrapper_show--OsJr-";
export var banner = "GDPRBanner-module--banner--6PZBE";
export var banner__text = "GDPRBanner-module--banner__text--Dfz7+";
export var banner__button = "GDPRBanner-module--banner__button--DXkMl";